import { Link } from "react-router-dom";
import { t } from "ttag";

import { POST_MEETING_STATUS } from "@/features/consultations/models";
import type { Appointment } from "@/features/consultations/models";
import { formatDate, formatTime } from "@/shared/lib";
import { Badge, DocumentIcon, EmptyState, Table } from "@/shared/ui";
import { formatFullName } from "@/shared/utils";

interface PastAppointmentsTableProps {
  sessions: Appointment[];
}

export const PastAppointmentsTable = ({
  sessions,
}: PastAppointmentsTableProps) => {
  return (
    <Table.Root>
      <Table.Header>
        <Table.Row>
          <Table.Head>{t`Coach`}</Table.Head>
          <Table.Head>{t`Date`}</Table.Head>
          <Table.Head>{t`Time`}</Table.Head>
          <Table.Head>{t`Type`}</Table.Head>
          <Table.Head>{t`Status`}</Table.Head>
        </Table.Row>
      </Table.Header>

      <Table.Body>
        {sessions.length ? (
          sessions.map(
            ({ id, provider, startTime, endTime, pmStatus, videoUrl }) => (
              <Table.Row key={id}>
                <Table.Cell>
                  {provider?.fullName ? formatFullName(provider.fullName) : "-"}
                </Table.Cell>

                <Table.Cell>{formatDate(startTime)}</Table.Cell>

                <Table.Cell>
                  {`${formatTime(startTime)} - ${formatTime(endTime)}`}
                </Table.Cell>

                <Table.Cell>{t`Journey support`}</Table.Cell>

                <Table.Cell>
                  <Badge
                    color={
                      pmStatus !== POST_MEETING_STATUS.CANCELLED
                        ? "light-secondary"
                        : "red"
                    }
                    size="x-small"
                    className="min-w-20"
                  >
                    {pmStatus}
                  </Badge>
                </Table.Cell>

                <Table.Cell>
                  {videoUrl ? (
                    <Link to={videoUrl} target="_blank" rel="noreferrer">
                      <DocumentIcon className="size-4" />
                    </Link>
                  ) : (
                    "-"
                  )}
                </Table.Cell>
              </Table.Row>
            ),
          )
        ) : (
          <Table.Row className="pointer-events-none">
            <Table.Cell colSpan={5}>
              <EmptyState.Root className="border-none">
                <EmptyState.Icon />
                <EmptyState.Description>
                  {t`You haven't had any appointments yet`}
                </EmptyState.Description>
              </EmptyState.Root>
            </Table.Cell>
          </Table.Row>
        )}
      </Table.Body>
    </Table.Root>
  );
};
